<template>
  <div class="meiwen">
    <div class="title">
      <div class="left">官方活动</div>
      <!-- <div class="right" v-on:click="showAll()">查看全部</div> -->
    </div>
    <ul>
      <li v-for="item in list" :key="item.id" v-on:click="goArticle(item.id)"> 
        <div class="left">
          <van-image
            width="8rem"
            height="6rem"
            fit="contain"
            lazy-load
            :src="GLOBAL.URL + '/upload/' + item.thumbnail"
          />
        </div>
        <div class="right">
          <div class="titleCss">{{item.post_title}}</div>
          <div class="pdate">
            <div>有{{item.post_hits*item.id+231}}看过</div>
            <div>{{item.published_time}}</div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "meiwen",
  props: {
    list: {},
  },
  data() {
    return {
    };
  },
  methods: {
      goArticle(v){
          this.$router.push('/article/detail/'+v);
      },
      showAll(){
          this.$router.push('/articlelist');
      }
  }
};
</script>
<style lang="scss" scoped>
.meiwen {
  margin-top: 0.7rem;
  width: 100%;
  background-color: #fff;
  padding: 10px;
  .title {
    display: flex;
    justify-content: space-between;
    padding: 0rem 0.5rem 1rem 0rem;
    line-height: 1.8rem;
    color: #222333;
    .left {
      font-size: 16px;
    }
  }
  ul {
    li {
      padding: 0.5rem;
      height: 7rem;
      overflow: hidden;
      display: flex;
      .left {
        flex-basis: 8rem;
        img {
          margin: 0 auto 0;
          vertical-align: middle;
        }
      }
      .right {
        .titleCss {
          height: 3rem;
          line-height: 3rem;
          overflow: hidden;
          color: #222333;
        }
        padding-left: 2rem;
        flex-grow: 1;
        line-height: 2.5rem;
        text-align: left;
        .pdate {
          color: #1baeae;
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>